import React from "react";

const Footer = () => {
  return (
    <div className="container-fluid text-center bg bg-dark text-light p-3">
      <p>Create By Tek kheng</p>
    </div>
  );
};

export default Footer;
